// Copyright 2025 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
import { Component, Inject } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NameValidatorModel } from './name-dialog.models';

@Component({
  selector: 'name-dialog',
  templateUrl: './name-dialog.component.html',
  styleUrls: ['./name-dialog.component.scss'],
  standalone: false,
})
export class NameDialogComponent {
  public title = '';
  public message = '';
  public removeArtifacts = true;
  public form: UntypedFormGroup;
  public validators: Array<NameValidatorModel> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NameDialogComponent>,
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group({
      name: [data.nameValue, [Validators.required]],
    });

    if (data.showDescription) {
      this.form.addControl(
        'description',
        this.formBuilder.control(data.descriptionValue ?? '')
      );
    }

    if (data.validators) {
      this.validators = data.validators;
      const validators = (data.validators as Array<NameValidatorModel>).map(
        (x) => x.validator
      );
      this.form.controls['name'].addValidators(validators);
    }
  }

  get name(): AbstractControl {
    return this.form.controls['name'];
  }

  onClick(): void {
    this.data.artifacts && this.data.artifacts.length > 0
      ? (this.data.removeArtifacts = this.removeArtifacts)
      : (this.data.removeArtifacts = false);
    this.data.nameValue = this.name.value;
    if (this.data.showDescription) {
      this.data.descriptionValue = this.form?.get('description')?.value;
    }
    this.dialogRef.close(this.data);
  }
}
